import React, { useState } from 'react'
import { ValidationError } from "../../../assets/ErrorTypes";

export const useBlsInput = inputData => {
    const [value, setValue] = useState(inputData.value ?? "")
    const [label, setLabel] = useState(inputData.label ?? "labelAdı")
    const [placeHolder, setPlaceHolder] = useState(inputData.placeHolder ?? "")
    const [isLabelHidden, setIsLabelHidden] = useState(inputData.isLabelHidden ?? false)
    const [isHidden, setIsHidden] = useState(inputData.isHidden ?? false)
    const [disabled, setDisabled] = useState(inputData.disabled ?? false)
    const [allowBlank, setAllowBlank] = useState(inputData.allowBlank ?? true)

    const reset = () => {
        setValue(inputData.value ?? "")
        setLabel(inputData.label ?? "labelAdı")
        setPlaceHolder(inputData.placeHolder ?? "")
        setIsLabelHidden(inputData.isLabelHidden ?? false)
        setIsHidden(inputData.isHidden ?? false)
        setDisabled(inputData.disabled ?? false)
        setAllowBlank(inputData.allowBlank ?? true)
    }

    const checkRequired = () => {
        if (!allowBlank) {
            if (isNullOrEmpty()) {
                throw new ValidationError(`${label.replace(":", "")} alanı zorunludur`)
            }
        }
    }

    const clear = () => {
        setValue("");
    }
    const hide = () => setIsHidden(true);
    const show = () => setIsHidden(false);

    const isNullOrEmpty = () => {
        return (!value || value === "");
    }

    return {
        value, setValue,
        label, setLabel,
        isHidden, setIsHidden,
        isLabelHidden, setIsLabelHidden,
        disabled, setDisabled,
        placeHolder, setPlaceHolder,
        clear, isNullOrEmpty,
        allowBlank, setAllowBlank,
        checkRequired, reset,
        hide, show,
    }
}

const BlsInput = ({inputStyle, labelStyle, containerStyle, inputState, type = 'text', uppercase = false, forRow = false, labelAlign = 'left', onChange = () => { }, onKeyPress = () => { }, onBlur = () => { }, onEnterPress = () => { }}) => {
    const isValid = inputState?.allowBlank ? true : !inputState.isNullOrEmpty();
    return (
        forRow
            ? <input
                defaultValue={inputState.value}
                placeholder={inputState.placeHolder}
                onBlur={onBlur}
                value={inputState.value}
                onChange={e => {
                    if (uppercase) {
                        inputState.setValue(e.target.value.toLocaleUpperCase('TR'))
                    } else {
                        inputState.setValue(e.target.value);
                    }
                    onChange(e);
                }}
                onKeyPress={e => {
                    onKeyPress(e)

                    if (e.key === "Enter") {
                        //inputState.setValue(e.target.value);
                        onEnterPress(e)
                    }
                }}
                readOnly={inputState.disabled}
                type={type}
                style={{
                    boxShadow: '1px 1px 5px #aeaeae',
                    borderColor: '#f0f0f0',
                    marginLeft: "0%",
                    height: '20px',
                    float: "left",
                    fontSize: '.73rem',
                    width: inputState.isLabelHidden ? '100%' : labelAlign === 'left' ? '50%' : '100%',
                    borderRadius: 3,
                    borderWidth: 1,
                    outline: inputState.disabled ? "inherit" : "inital",
                    textTransform: uppercase ? 'uppercase' : 'none',
                    cursor: inputState.disabled ? 'not-allowed' : 'text',
                    display: inputState.isHidden ? 'none' : 'block',
                    border: isValid ? 'none' : '1px solid red',
                    ...inputStyle
                }}
            />
            : <div style={{
                marginTop: '1%',
                borderWidth: 0,
                border: 'none',
                display: inputState.isHidden ? 'none' : 'flex',
                flexDirection: labelAlign === 'left' ? 'row' : 'column',
                ...containerStyle
            }}>
                <label
                    className='dark:text-white text-black'
                    style={{
                        borderWidth: '1px',
                        borderColor: '#f0f0f0',
                        borderRadius: 3,
                        width: labelAlign === 'left' ? '38%' : '100%',
                        height: '20px',
                        float: "left",
                        paddingLeft: labelAlign === 'left' ? "2%" : "0%",
                        textAlign: "left",
                        backgroundColor: "transparent",
                        overflow: "hidden",
                        fontSize: '.73rem',
                        display: inputState.isLabelHidden ? 'none' : 'block',
                        ...labelStyle
                    }}>{inputState.label}</label>

                <input
                    placeholder={inputState.placeHolder}
                    onBlur={onBlur}
                    value={inputState.value}
                    onChange={e => {
                        if (uppercase) {
                            inputState.setValue(e.target.value.toLocaleUpperCase('TR'))
                        } else {
                            inputState.setValue(e.target.value);
                        }
                        onChange(e);
                    }}
                    onKeyPress={e => {
                        onKeyPress(e)

                        if (e.key === "Enter") {
                            onEnterPress(e)
                        }
                    }}
                    readOnly={inputState.disabled}
                    type={type}
                    style={{
                        boxShadow: '1px 1px 5px #aeaeae',
                        borderColor: '#f0f0f0',
                        marginLeft: "0%",
                        height: '20px',
                        float: "left",
                        fontSize: '.73rem',
                        width: inputState.isLabelHidden ? '100%' : labelAlign === 'left' ? '50%' : '100%',
                        borderRadius: 3,
                        borderWidth: 1,
                        outline: inputState.disabled ? "inherit" : "inital",
                        textTransform: uppercase ? 'uppercase' : 'none',
                        cursor: inputState.disabled ? 'not-allowed' : 'text',
                        display: inputState.inputHide ? 'none' : 'block',
                        border: isValid ? 'none' : '1px solid red', //test
                        ...inputStyle
                    }}
                />
            </div>

    );
}

export default BlsInput